import React, {useState} from 'react';
import "./footer.css";
import instaIcon from "../../res/img/instagram.svg";
import telegramIcon from "../../res/img/telegram.svg";
import facebookIcon from "../../res/img/facebook.svg";
import youtubeIcon from "../../res/img/youtube.svg";
import Api from "../../services/api";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import Loading from "../loading/loading";
import {devices} from "../../utils/devices";
import logo from "../../res/img/pure-logo.png";


const Footer = () => {
    let device = devices();
    const setting = useSelector(state => state.setting.setting && state.setting.setting )
    const links = setting && setting.links && !setting.links.instagram && JSON.parse(setting.links)
    const [loading , setLoading] = useState(false)

    const [email, setEmail] = useState("")
    const [name, setName] = useState("")
    const [number, setNumber] = useState("")
    const [family, setFamily] = useState("")

    const validation = () => {
      if(name === "") {
          toast.error("لطفا نام را وارد کنید")
          return false
      }
      if(family === "") {
          toast.error("لطفا نام خانوادگی را وارد کنید")
          return false
      }
      if(email === "") {
          toast.error("لطفا ایمیل را وارد کنید")
          return false
      }
      if(number === "") {
          toast.error("لطفا شماره تلفن را وارد کنید")
          return false
      }
      return true
    }
    const handleEmail = () => {
        if (!validation()) return false
        setLoading(true)
        new Api().post("/newsLetter", {
            email: email,
            name: name,
            number: number,
            family: family,
        }).then((res) => {
            setLoading(false)
            toast.success(res.msg)
        }).catch((res) => {
            setLoading(false)
            toast.success(res.msg)
        })
    }
    return (
        <>
            <div className={"footer"}>
                <div id={"top-flag"}/>
                <div className={"container"}>
                    <div className={"footer-column"}>
                        <div className={"footer-column-item"}>
                            {
                                setting && setting.title &&
                                <div className={"footer-logo"}>
                                    <img src={logo}/>
                                </div>
                            }

                           <div>
                                <span className={"footer-column-item-title"}>
                               {
                                   setting && setting.title &&
                                   <span>
                                    {setting && setting.title}
                                </span>
                               }
                            </span>
                               {
                                   setting && setting.introduce &&
                                   <>
                                       <p>
                                           {setting &&  setting.introduce}
                                       </p>
                                       <div className={"phone"}>
                                           <div onClick={() => {window.location.assign(device === 'desktop'? `https://web.whatsapp.com/send?phone=31641012277` : "https://api.whatsapp.com/send?phone=31641012277")}}>
                                               <img src="https://img.icons8.com/color/48/000000/whatsapp--v6.png"/>
                                               <span>تماس  ( واتساپ ) :</span>
                                               <span>{"641012277 - ( 0031 )"}</span>
                                           </div>
                                       </div>
                                   </>
                               }
                           </div>
                        </div>
                        <div className={"footer-column-item"}>
                            <span className={"footer-column-item-title"}>
                                <span>
                                     در شبکه های اجتماعی ...
                                </span>
                            </span>
                            <div className={"social"}>
                                {
                                    setting &&  links && links.instagram &&
                                    <a target={"_blank"}  href={ setting && links && links.instagram}>
                                        <img src={instaIcon}/>
                                    </a>
                                }
                                {
                                    setting && links &&  links.telegram &&
                                    <a target={"_blank"}  href={ setting &&  links && links.telegram}>
                                        <img src={telegramIcon}/>
                                    </a>
                                }
                                {
                                    setting &&  links &&  links.facebook &&
                                    <a target={"_blank"}  href={ setting &&  links && links.facebook}>
                                        <img src={facebookIcon}/>
                                    </a>
                                }
                                {
                                    setting &&  links &&  links.youtube &&
                                    <a target={"_blank"}  href={ setting &&  links && links.youtube}>
                                        <img src={youtubeIcon}/>
                                    </a>
                                }
                            </div>

                        </div>
                        <div className={"footer-column-item"}>
                        <span className={"footer-column-item-title"}>
                            <span>
                                عضویت و اطلاع از آخرین خبرها
                            </span>
                        </span>
                            <div className={"footer-input"}>
                                <div className={"footer-input-item"}>
                                    <input value={name} onChange={(e) => {
                                        setName(e.target.value)
                                    }} placeholder={"نام "} type={"name"}/>
                                </div>
                                <div className={"footer-input-item"}>
                                    <input value={family} onChange={(e) => {
                                        setFamily(e.target.value)
                                    }} placeholder={"نام خانوادگی "} type={"family"}/>
                                </div>
                                <div className={"footer-input-item"}>
                                    <input value={email} onChange={(e) => {
                                        setEmail(e.target.value)
                                    }} placeholder={"ایمیل "} type={"email"}/>
                                </div>
                                <div className={"footer-input-item"}>
                                    <input value={number} onChange={(e) => {
                                        setNumber(e.target.value)
                                    }} placeholder={"شماره "} type={"number"}/>
                                </div>
                                <div className={"footer-input-item-btn"}>
                                    <div onClick={()=>{handleEmail()}}>
                                    {loading ?<Loading /> : "ثبت"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id={"down-flag"}>
                    Copyright 2021 | Onlinenederlandseschool | All Right Reserved
                </div>
            </div>

        </>


    );
};

export default Footer;
